import styled from "styled-components";

export const ProductCompleteWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductCompleteBox = styled.div`
  width: calc(100% - 52px);
  padding: 54px 15px 24px 15px;
  background: #fff;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;

  color: var(--Black-500, #202020);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 22.4px */
`;

export const ProductCompleteButton = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #6436e7;

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
`;
